import type { ReactNode } from "react";
import { Link } from "react-router-dom";

export default function LegalDocument({
  title,
  children,
}: {
  title: string;
  children: ReactNode;
}) {
  return (
    <div className="layout">
      <main className="layout-main layout-main--legal">
        <Link to="/" className="legal-back">
          ← Home
        </Link>
        <h1>{title}</h1>
        <article className="legal-body">{children}</article>
      </main>
    </div>
  );
}
